import React, {createRef, useContext} from "react";
import {motion} from "framer-motion";
import "./EducationCard.scss";
import StyleContext from "../../contexts/StyleContext";
import Button from "../button/Button"; // Import komponen Button

export default function EducationCard({school}) {
  const imgRef = createRef();

  const GetDescBullets = ({descBullets}) => {
    return descBullets
      ? descBullets.map((item, i) => (
          <li key={i} className="subTitle">
            {item}
          </li>
        ))
      : null;
  };
  const {isDark} = useContext(StyleContext);

  if (!school.logo)
    console.error(`Image of ${school.name} is missing in education section`);

  return (
    <div>
      <motion.div
        className="education-card"
        initial={{x: -50, opacity: 0}}
        whileInView={{x: 0, opacity: 1}}
        transition={{duration: 1}}
        viewport={{once: true}}
      >
        {school.logo && (
          <div className="education-card-left">
            <img
              crossOrigin={"anonymous"}
              ref={imgRef}
              className="education-roundedimg"
              src={school.logo}
              alt={school.schoolName}
            />
          </div>
        )}
        <div className="education-card-right">
          <h5 className="education-text-school">{school.schoolName}</h5>

          <div className="education-text-details">
            <h5
              className={
                isDark
                  ? "dark-mode education-text-subHeader"
                  : "education-text-subHeader"
              }
            >
              {school.subHeader}
            </h5>
            <p
              className={`${isDark ? "dark-mode" : ""} education-text-duration`}
            >
              {school.duration}
            </p>
            <p className="education-text-desc">{school.desc}</p>
            <div className="education-text-bullets">
              <ul>
                <GetDescBullets descBullets={school.descBullets} />
              </ul>
            </div>

            {/* --- BAGIAN TOMBOL --- */}
            {school.thesisLink && (
              <div
                className="education-card-button"
                style={{marginTop: "20px"}}
              >
                <Button
                  text="View Thesis Archive"
                  newTab={true}
                  href={school.thesisLink}
                />
              </div>
            )}
            {/* --------------------- */}
          </div>
        </div>
      </motion.div>

      <motion.div
        className="education-card-border"
        initial={{width: 0}}
        whileInView={{width: "100%"}}
        transition={{duration: 2}}
        viewport={{once: true}}
      ></motion.div>
    </div>
  );
}
